import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { createAddressBookSlice } from '../../features/address-book/stores/address-book-slice';
import type { AddressBookSlice } from '../../features/address-book/stores/address-book-slice.types';
import { createAddressSlice } from './slices/global-address-slice';
import type { AddressSlice } from './slices/global-address-slice.types';

export type AddressStore = AddressSlice & AddressBookSlice;

export const useAddressStore = create<AddressStore>()(
  devtools(
    (...a) => ({
      ...createAddressSlice(...a),
      ...createAddressBookSlice(...a),
    }),
    {
      name: 'AddressStore',
      enabled: process.env.REACT_APP_ZUSTAND_DEVTOOLS === 'true',
      trace: true,
    },
  ),
);
